import { useParams } from "react-router-dom";
import { Card } from "../components/Card";

const docs = {
  privacy: {
    title: "Privacy Policy",
    body: `
**Last updated: today**

We collect only the data needed to deliver your nail-design experience: your email, name, phone (optional), preferences, the designs you generate, your bookings, and payment metadata returned by Stripe (we never see your card number).

**How we use it.** Generating personalised designs, rendering photoreal previews, processing payments, sending confirmations and reminders, and showing you your history.

**Sharing.** We share data with trusted service providers strictly to operate the service. We do not sell your data.

**Storage.** Data is kept in secure cloud systems. Generated images may be cached so we don't regenerate identical prompts; cached images contain no PII.

**Your rights.** You can download all your data ("Download my data" in Profile) or permanently delete your account ("Delete my account" in Profile) at any time. EU/UK/CA residents have additional rights under GDPR / UK GDPR / PIPEDA, including the right to lodge a complaint with your supervisory authority.

**Cookies.** We store a small "cookie consent" flag and your theme preference in localStorage. We do not use third-party advertising trackers.

**Contact.** hello@ogeeyesthetics.com
    `.trim(),
  },
  terms: {
    title: "Terms of Service",
    body: `
**Last updated: today**

By using Oge Eyesthetic Nail Studio you agree to these terms.

**Bookings.** A booking is a request to reserve time with a technician. Confirmation depends on the technician (instant if they have auto-confirm on, otherwise manual). You can reschedule or cancel up to 24 hours before your appointment without charge.

**Payments.** Payments are processed by Stripe. Tips, taxes, and any promo discounts are itemised at checkout. Refunds for cancellations within 24 hours are at the technician's discretion.

**No-shows.** A booking is automatically marked as a no-show 30 minutes after the start time if not confirmed by the technician. A no-show fee may apply.

**AI-generated content.** Designs and rendered images are produced by AI and may not perfectly match the final result. Use them as inspiration; the technician will adapt.

**Acceptable use.** Don't try to break, scrape, or abuse the platform. Don't upload images you don't have rights to. Don't use the service for anything illegal.

**Liability.** We provide the service "as is". We're not liable for indirect or consequential damages. Where the law requires it, our maximum liability is limited to the amount you paid us in the prior 12 months.

**Termination.** Either side can end the relationship at any time. We may suspend accounts that violate these terms. If we terminate you, we'll refund any unused prepaid amounts.

**Governing law.** These terms are governed by the laws of your jurisdiction of residence.
    `.trim(),
  },
};

export function LegalScreen() {
  const { doc } = useParams();
  const d = docs[doc];
  if (!d) return <Card><div style={{ textAlign: "center", padding: 40 }}>Document not found.</div></Card>;
  // Tiny markdown-ish renderer (bold + paragraphs only)
  const blocks = d.body.split(/\n\n+/);
  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)", paddingBottom: 80 }}>
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "30px 16px" }}>
        <h1 style={{ fontFamily: "var(--font-display)", color: "var(--text)", marginBottom: 18 }}>{d.title}</h1>
        {blocks.map((b, i) => (
          <p key={i} style={{ color: "var(--text-soft)", lineHeight: 1.7, marginBottom: 14, whiteSpace: "pre-wrap" }}
             dangerouslySetInnerHTML={{ __html: b.replace(/\*\*(.+?)\*\*/g, '<strong style="color:var(--text)">$1</strong>') }} />
        ))}
      </div>
    </div>
  );
}
